import { phonePrefixOptions } from 'src/utils/phonePrefixes';

/**
 * If phone number is a long string containing country code, this function will parse it into two separate strings.
 * Returns object with phone country code and phone number as two separate properties
 */
export const useParsePhoneNumberByPrefix = (
  fullPhoneNumber: string
): { countryPrefix: string; phoneNumber: string } => {
  const parsedPhoneNumber = {
    countryPrefix: '',
    phoneNumber: '',
  };

  const matchCountryPrefix = fullPhoneNumber.match(/^(\+\d+)\s(.+)$/); // The country code (e.g., "+420")

  if (matchCountryPrefix) {
    parsedPhoneNumber.countryPrefix = matchCountryPrefix[1];
    parsedPhoneNumber.phoneNumber = matchCountryPrefix[2];
    return parsedPhoneNumber;
  }

  // Numbers are stored normalised, without the space the branch above needs, so
  // the prefix is taken from the codelist instead of guessed from the digits:
  // "+420123456789" has no other way of saying where the prefix ends. No entry
  // is currently the start of another; the longest match is picked in case one
  // ever is.
  const knownPrefix = phonePrefixOptions
    .filter((prefix) => fullPhoneNumber.startsWith(prefix))
    .sort((a, b) => b.length - a.length)[0];

  if (
    knownPrefix !== undefined &&
    fullPhoneNumber.length > knownPrefix.length
  ) {
    parsedPhoneNumber.countryPrefix = knownPrefix;
    parsedPhoneNumber.phoneNumber = fullPhoneNumber.slice(knownPrefix.length);
    return parsedPhoneNumber;
  }

  parsedPhoneNumber.countryPrefix = '';
  parsedPhoneNumber.phoneNumber = fullPhoneNumber;

  return parsedPhoneNumber;
};
